import http from "@/utils/httpRequest";

// let baseURL="/api/workbenchlh";
// 项目跟踪招标项目审批流程
export const apiworkBenchIndexAuditDetails = (params) => {
  return http.get(
    `/workBenchIndex/auditDetails/${params.type}?bidId=${params.bidId}&projectState=${params.projectState}`,
    { baseURL }
  );
};

// 项目跟踪 所有数据的条数
export const apiworkBenchIndexcountProjectTracking = (params) => {
  return http.post(
    `/workBenchIndex/countProjectTracking`,
    { ...params },
    { baseURL }
  );
};

// 项目跟踪 工程建设数据条数
export const apiworkBenchIndexprojectStatusCount = (params) => {
  return http.post(
    `/workBenchIndex/projectStatusCount/${params.type}`,
    { ...params },
    { baseURL }
  );
};
